<app-national-park
  bannerImage="../../../../../assets/img/others/ngorongoro.jpg"
  [largeImgHeightAndBackgroundPosition]="['420px', 'center left']"
  [medImgHeightAndBackgroundPosition]="['350px', '40% 0%']"
  [smallImgHeightAndBackgroundPosition]="['250px', '40% 0%']"
  [tripEntries]="tripEntries"
  [mapLat]="mapLat"
  [mapLng]="mapLng"
  [parkBoundaries]="parkBoundaries"
  [zoom]="9"
  [galleries]="[zebraPhoto, femaleLionPhoto, coexistPhoto]"
  [animalEntries]="animalEntries"
  [hasBadge]="true"
  [paragraphs]="parkText.paragraphs"
  [paragraphHeaders]="parkText.paragraphHeaders"
  [factsHeader]="parkText.factsHeader"
  [factSet]="parkText.facts"
  [badgeHtml]="parkText.badge"
  [isOneSpot]="false"
  [animals]="true"
  tripListParkName="Ngorongoro Crater Conservation Area"
  parkId="Ngorongoro Crater"
  mobileTripListHeight="694px"
  [desktopCircleWidths]="circleWidthsDesktop"
  [mobileCircleWidths]="circleWidthsMobile"
  parkRoute="ngorongoro"
>
</app-national-park>
